import { getApiUrl } from '../../config/api';

async function readJson(response) {
  const text = await response.text();
  if (!text) return {};
  try {
    return JSON.parse(text);
  } catch {
    throw new Error(text || `Request failed (${response.status})`);
  }
}

async function requestJson(endpoint, options = {}) {
  const response = await fetch(getApiUrl(endpoint), {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });
  const data = await readJson(response);
  if (!response.ok) {
    throw new Error(data.error || data.message || `Request failed (${response.status})`);
  }
  return data;
}

export async function prepareInterviewerFeedback({
  bookingId,
  roomId,
  interviewerEmail,
  actorEmail,
  interviewerToken,
}) {
  return requestJson('/api/meeting/interviewer-feedback/prepare', {
    method: 'POST',
    body: JSON.stringify({
      booking_id: bookingId,
      room_id: roomId,
      interviewer_email: interviewerEmail,
      actor_email: actorEmail,
      interviewer_token: interviewerToken || undefined,
    }),
  });
}

export async function deferInterviewerFeedback({
  bookingId,
  roomId,
  interviewerEmail,
  actorEmail,
  interviewerToken,
  keepalive = false,
}) {
  return requestJson('/api/meeting/interviewer-feedback/defer', {
    method: 'POST',
    keepalive,
    body: JSON.stringify({
      booking_id: bookingId,
      room_id: roomId,
      interviewer_email: interviewerEmail,
      actor_email: actorEmail,
      interviewer_token: interviewerToken || undefined,
    }),
  });
}

export async function scheduleInterviewerFeedbackAutoEmail({
  bookingId,
  roomId,
  interviewerEmail,
  actorEmail,
  interviewerToken,
  keepalive = false,
}) {
  return requestJson('/api/meeting/interviewer-feedback/schedule-auto-email', {
    method: 'POST',
    keepalive,
    body: JSON.stringify({
      booking_id: bookingId,
      room_id: roomId,
      interviewer_email: interviewerEmail,
      actor_email: actorEmail,
      interviewer_token: interviewerToken || undefined,
    }),
  });
}

export async function cancelInterviewerFeedbackAutoEmail({
  bookingId,
  roomId,
  interviewerEmail,
  actorEmail,
  interviewerToken,
}) {
  return requestJson('/api/meeting/interviewer-feedback/cancel-auto-email', {
    method: 'POST',
    body: JSON.stringify({
      booking_id: bookingId,
      room_id: roomId,
      interviewer_email: interviewerEmail,
      actor_email: actorEmail,
      interviewer_token: interviewerToken || undefined,
    }),
  });
}

export async function fetchInterviewerFeedbackSession(token) {
  const safe = encodeURIComponent(token || '');
  return requestJson(`/api/meeting/interviewer-feedback/session?token=${safe}`);
}

export async function saveInterviewerFeedbackSession(token, answers) {
  return requestJson('/api/meeting/interviewer-feedback/session', {
    method: 'PUT',
    body: JSON.stringify({ token, answers }),
  });
}

export async function submitInterviewerFeedback(token, answers, actorEmail) {
  return requestJson('/api/meeting/interviewer-feedback/submit', {
    method: 'POST',
    body: JSON.stringify({ token, answers, actor_email: actorEmail }),
  });
}
